import { render, staticRenderFns } from "./RequestToken.vue?vue&type=template&id=77a8fc40&scoped=true"
import script from "./RequestToken.vue?vue&type=script&lang=js"
export * from "./RequestToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a8fc40",
  null
  
)

export default component.exports